var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('input',{staticClass:"GCB2-audience-setting-base-input",class:{ focused: _vm.focused },domProps:{"value":_vm.value},on:{"click":function($event){$event.stopPropagation();return (() => {}).apply(null, arguments)},"input":_vm.update,"keypress":_vm.checkInputIsIntNumberWithMinus}})
}
var staticRenderFns = []

export { render, staticRenderFns }